(function($) {
/**
 * @see https://cookieconsent.insites.com/documentation/about-cookie-consent/
 */
cookieConsent = function() {
  var parseData = function(){
    cookieConsentVars.enabled = window.cookie_data.show_cookie;
    if (window.cookie_data.message !== '' && window.cookie_data.message !== cookieConsentVars.message){
      cookieConsentVars.message = window.cookie_data.message;
    }
    if (window.cookie_data.dismiss !== '' && window.cookie_data.dismiss !== cookieConsentVars.dismiss){
      cookieConsentVars.dismiss = window.cookie_data.dismiss;
    }

    if (window.cookie_data.read_more_text !== '' && window.cookie_data.read_more_text !== cookieConsentVars.read_more_text){
      cookieConsentVars.read_more_text = window.cookie_data.read_more_text;
    }

    if (window.cookie_data.read_more_link !== '' && window.cookie_data.read_more_link !== cookieConsentVars.read_more_link){
      cookieConsentVars.read_more_link = window.cookie_data.read_more_link;
    }
  };
  var initCookie = function(){
    window.cookieconsent.initialise({
      palette: {
      },
      enabled: cookieConsentVars.enabled,
      content: {
        header: cookieConsentVars.header,
        message: cookieConsentVars.message,
        dismiss: cookieConsentVars.dismiss,
        allow: cookieConsentVars.allow,
        deny: cookieConsentVars.deny,
        link: cookieConsentVars.read_more_text,
        href: cookieConsentVars.read_more_link,
      }
    });
  };
  $(document).ready(function(){
    parseData();
    initCookie();
  });
};
})(jQuery);
